import moment from 'moment'

export const countdownBehavior = {
    mixins:[],
    data() {
        return {
            countdownTimer:null,
            progress:null,
            progressClass:null,
            years:"",
            months:"",
            days:"",
            hours:"",
            minutes:"",
            seconds:"",
            preOutput:"",
            finalDate:null,
            onInitTime:new Date().getTime(),
            closeCountDownAfterEnd:false,
            stopCountDownAfterEnd:false,
            customStartDate:null,
            customEndDate:null,
            frozenRemainingMs:null,
            onUpdateStateClb:null,
            lastState:null
        }
    },
    computed: {

        lblPrefixStartIn(){
            return this.$t('eventWillStart', { event: this.$tc('event') })
        },
        lblPrefixEndIn(){
            return this.$t('eventWillEnd', { event: this.$tc('event') })
        },
        lblPrefixEndBefore(){
            return "~"
            // return "this.$t('app_countdown_ended_before')"
        },
        lblPrefixFinished(){
            return "~"
            // return this.$t('app_countdown_ended')
        },
        startDate(){
            let startDate= (this.customStartDate)?this.customStartDate:((this.event)?(this.event.date_start+'T'+this.event.time_start):null);
            return (startDate)?new Date(Date.parse(startDate)):null;
        },
        endDate(){
            let endDate= (this.customEndDate)?this.customEndDate:((this.event)?(this.event.date_end+'T'+this.event.time_end):null);
            return (endDate)?new Date(Date.parse(endDate)):null;
        },
        getCountdownDate(){
            let d=(this.finalDate)?this.finalDate:new Date().getTime();
            return moment(d).format();
        },
        getTitle(){
            return (this.preOutput)?this.preOutput:'';
        }

    },
    beforeDestroy(){
        this.stopCountdown();
    },
    methods:{
        startCountdown(){
            if(!this.countdownTimer){
                this.countdownTimer=setInterval(this.countdownLoop,500);
            }
        },
        stopCountdown(){
            if(this.countdownTimer){
                clearInterval(this.countdownTimer);
                this.countdownTimer=null;
            }
        },
        calculateOutput(distance){

            var distancedate = moment(distance); // miliseconds from epoch
            var momentDate=moment.duration(distance);
            if(momentDate && distancedate){
                this.years = momentDate.years();//Math.abs(distancedate.getUTCFullYear() - 1970);
                this.months = momentDate.months();
                this.days = momentDate.days();//Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / ((1000 * 60 * 60 * 24)));
                this.hours = momentDate.hours();//Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.minutes = momentDate.minutes();//Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = momentDate.seconds();//Math.floor((distance % (1000 * 60)) / 1000);
            }
        },
        scale (num, in_min, in_max, out_min, out_max){
            return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
        },
        calculateProgress(lblPreFix,val,min,max,calculateProgress){
            var distance=max-val;
            this.finalDate=max;
            this.preOutput=lblPreFix;
            this.calculateOutput(distance);
            this.progress=(calculateProgress)?100-this.scale(val,min,max,0,100):100;
        },
        // team countdown not started yet: the full countdown stands still with a full ring
        showFrozen(remainingMs,now){
            this.finalDate=now+remainingMs;
            this.preOutput=this.lblPrefixEndIn;
            this.calculateOutput(remainingMs);
            this.progress=100;
        },
        countdownLoop(){
            
            if(this.startDate && this.endDate &&this.startDate.getTime()>0 && this.endDate.getTime()>0){
                let now = new Date().getTime();
                let startDateTime=this.startDate.getTime();
                let endDateTime=this.endDate.getTime();
                let eventBeforeStart=((startDateTime - now)>0);
                let eventAfterEnd= ((endDateTime-now)<0);
                let currentState=null;

                if(eventBeforeStart){
                    currentState="before_start";
                    this.calculateProgress(this.lblPrefixStartIn,now,this.onInitTime,startDateTime,true);
                }else if(eventAfterEnd){
                    currentState="after_end";
                    let title=(this.closeCountDownAfterEnd)?this.lblPrefixFinished:this.lblPrefixEndBefore;
                    this.calculateProgress(title,endDateTime,now,now,false);
                }else{
                    currentState="in_time";
                    // the fixed end wins once it is nearer than the frozen countdown
                    if(this.frozenRemainingMs>0 && (endDateTime-now)>this.frozenRemainingMs){
                        this.showFrozen(this.frozenRemainingMs,now);
                    }else{
                        this.calculateProgress(this.lblPrefixEndIn,now,startDateTime,endDateTime,true);
                    }
                }
                
                if(null!=this.lastState && this.lastState!=currentState){
                    this.emitUpdateState(currentState);
                }

                this.lastState=currentState;
                
            }
        },
        updateEventState(newState){
            let updateEventState=(null==this.customStartDate && null==this.customEndDate);
            if(updateEventState){
                this.setEventStatusLocally(newState);
            }
        },
        emitUpdateState(currentState){
            console.log(currentState);
            if(currentState=="in_time"){
                this.$emit('countdownStarted');
            }else if(currentState=="after_end"){
                this.$emit('countdownEnded');
                if(this.stopCountDownAfterEnd){
                    this.stopCountdown();
                }
            }
            if(typeof(this.onUpdateStateClb)=="function"){
                this.onUpdateStateClb(currentState);
            }
        }
    },

}